import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { SharedModule } from '../../shared/shared.module';
import { InternalUserRoutingModule } from './internal-user-routing.module';
import { InternalUserComponent } from './internal-user.component';
import { CollapsiblePanelLightModule } from 'src/app/shared/components/collapsible-panel-light/collapsible-panel-light.module';


@NgModule({
  declarations: [
    InternalUserComponent
  ],
  imports: [
    CommonModule,
    InternalUserRoutingModule,
    MatFormFieldModule,
    SharedModule,
    CollapsiblePanelLightModule,
  ]
})
export class InternalUserModule { }
